// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ApplicationInfo } from '@shared/commons/ApplicationInfo';
import { CustomEvent } from './CustomEvents';
import { SoundManager } from './SoundManager';
class _TradingLockUtils {
    constructor() {
        this.IsUseLockTradingByPassword = false; // #89340 & #94446
        this.TradingLock = {
            tradingLocked: false,
            LockTradingByPassword: false,
            TradingLockChanged: new CustomEvent(),
            updateTradingLock: function (locked, skip = false) {
                const isLocked = locked || ApplicationInfo.isExploreMode;
                if (this.LockTradingByPassword && !isLocked)
                    return;
                if (this.tradingLocked === isLocked)
                    return;
                this.tradingLocked = isLocked || ApplicationInfo.isExploreMode;
                if (!skip) {
                    this.TradingLockChanged.Raise();
                }
                SoundManager.tryPlaySound(isLocked ? SoundManager.SoundKeys.Lock : SoundManager.SoundKeys.Unlock);
                if (TradingLockUtils.IsUseLockTradingByPassword && isLocked) {
                    this.LockTradingByPassword = true;
                }
            }
        };
    }
    ResetBeforeDisconnection() {
        if (TradingLockUtils.TradingLock.LockTradingByPassword) {
            TradingLockUtils.TradingLock.LockTradingByPassword = false;
            TradingLockUtils.TradingLock.updateTradingLock(false, true);
        }
        TradingLockUtils.IsUseLockTradingByPassword = false; // #89340 & #94446
    }
}
export const TradingLockUtils = new _TradingLockUtils();
